module.exports = __webpack_public_path__ + "static/media/mail.c52e4960.svg";